import { useQuery, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEY } from 'es/app/business-logic/queryKey';
import { fetchUnknownUserTemplate } from 'es/app/views/system/sso-user-templates/fetchUnknownUserTemplate';
import Guid from 'es/core/types/Guid';
import { useCallback } from 'react';

const ONE_HOUR_MILLIS = 1000 * 60 * 60;

export function useUnknownUserTemplate(templateId?: Guid) {
    const queryClient = useQueryClient();
    const { data: template, isFetching: isFetchingTemplate } = useQuery({
        queryKey: [QUERY_KEY.unknownUserTemplate, templateId],
        enabled: !!templateId,
        queryFn: () => {
            if (!templateId) {
                throw new Error('Template ID is required');
            }
            return fetchUnknownUserTemplate(templateId);
        },
        staleTime: ONE_HOUR_MILLIS,
    });
    return {
        template,
        isFetchingTemplate,
        invalidateTemplate: useCallback(() => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEY.unknownUserTemplate, templateId],
            });
        }, [queryClient, templateId]),
    };
}
